"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentLanguage = exports.selectLanguages = exports.setLanguage = exports.languageSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var localization_1 = require("../../helpers/localization");
var initialState = {
    selected: localization_1.getLanguage(),
    list: [
        {
            code: 'hy',
            original: 'Հայերեն',
            short: 'Հայ',
            flag: 'flag-am',
        },
        {
            code: 'en',
            original: 'English',
            short: 'Eng',
            flag: 'flag-uk',
        },
        {
            code: 'ru',
            original: 'Русский',
            short: 'Рус',
            flag: 'flag-ru',
        },
    ],
};
exports.languageSlice = toolkit_1.createSlice({
    name: 'languages',
    initialState: initialState,
    reducers: {
        setLanguage: function (state, action) {
            state.selected = action.payload;
        },
    },
});
exports.setLanguage = exports.languageSlice.actions.setLanguage;
var selectLanguages = function (state) { return state.languages.list; };
exports.selectLanguages = selectLanguages;
var selectCurrentLanguage = function (state) {
    return state.languages.selected;
};
exports.selectCurrentLanguage = selectCurrentLanguage;
exports.default = exports.languageSlice.reducer;
